import { TextToSpeech } from '@capacitor-community/text-to-speech';
import { set, get } from '@/controllers/preferences'
import { globalSTT } from './STT'
import { toSpeechText } from '@/controllers/markdown';
//import Live2D from '@/controllers/Live2D';

export const state = {
    enabled: true,
    last_msg: "",
    langcode: 'en-US',
    speaking: false,
    queue_size: 0,
    onSpeechStart: () => {},
    onSpeechEnd: () => {}
}

const load = async () => {
    // console.log("calling load")
    // if (get("ttsEnabled") === null)
    //     set("ttsEnabled", false)
    state.enabled = false;//await get("ttsEnabled")
}
load()

export async function speak(text: string) {
    const rawText = toSpeechText(text)   
    const textMod = symbolsToWords(rawText);
    console.log(textMod);

    state.last_msg = text;
    //if (!state.enabled) return;

    // HACK: pause speech transcription while TTS running to avoid echo on devices that have it
    // stopSpeaking
    
    console.log(state.langcode)
    let r;
    state.onSpeechStart()
    state.speaking = true;
    ++state.queue_size;
    console.log("START", state)
    const Live2D = await import('@/controllers/Live2D');
    if (Live2D.isRunning()) {
        console.log("SPEAK START")
        globalSTT.pause();
        Live2D.stopSpeaking();
        r = await Live2D.speak(state.langcode.split("-")[0], textMod);
        if (state.queue_size < 2) globalSTT.resume();
        globalSTT.resume(); // debug
        console.log("SPEAK END")
    } else {
        globalSTT.pause();
        r = await TextToSpeech.speak({
            text: textMod,
            lang: state.langcode,//'ru-RU',
            rate: 1,//0.95,
            pitch: 1.2,
            volume: 1.0,
            category: 'ambient',
            queueStrategy: 1
        })
        if (state.queue_size < 2) globalSTT.resume();
        globalSTT.resume(); // debug
    }
    --state.queue_size;
    state.speaking = false;
    state.onSpeechEnd()
    console.log("END", state)

    return r;
}

export function stopSpeaking() {
    TextToSpeech.stop();
}

export function enable() {
    state.enabled = true;
    set("ttsEnabled", true)
    //speak(state.last_msg);
}

export function disable() {
    state.enabled = false;
    set("ttsEnabled", false)
    TextToSpeech.stop();
}

// Substitute unpronounceable symbols using words
function symbolsToWords(text: string): string {
    return text
        .replaceAll(" + ", " plus ")
        .replaceAll(" - ", " minus ")
        .replaceAll(" = ", " equals ")
        .replaceAll("\$(\d+)", (e) => e + " dollars ")
        .replaceAll("$", "")
        //.replaceAll(":", " such that ")
        .replaceAll("∈", " in ")
        .replaceAll(">", " greater than ")
        .replaceAll("<", " less than ")
        .replaceAll("…", " dot dot dot ")
        .replaceAll("...", " dot dot dot ")
        .replaceAll("e.g.", " for example ")
}

function punctuationSplit(text: string): string[] {
    return text
        .split(/([?!.,:`$"])/)
        .reduce((acc: string[], curr, index) => {
            if (index % 2 === 0)
                acc.push(curr);
            else
                acc[acc.length - 1] += curr
            return acc
        }, [])
}

class TTS {
    buffer = ""
    isSpeaking = false;
    isInferenceDone = false;
    enabled = true;
    onSpeakStart: (()=>void) = () => {}
    onSpeakEnd: (()=>void) = () => {}
    finisher: (()=>void) = () => {}

    inferenceStart() {
        this.buffer = "";
        this.isInferenceDone = false;
        this.onSpeakStart();
    }

    newInferenceResult(newMsgPart: string) {
        console.log("newInferenceResult")
        this.buffer += newMsgPart;

        this.buffer = this.buffer.replaceAll("e.g.", " for example ");

        if (!this.enabled) return;

        // delay potential speaking to receive more complete sentences
        setTimeout(() => {
            if (this.isSpeaking) return;
            //if (this.isInferenceDone) return;

            // Splitting stuff to say based on punctuation sounds nicer,
            // so prefer it if possible
            const punctSplit = punctuationSplit(this.buffer);
            const spaceSplit = this.buffer.split(" ");
            const words = punctSplit.length > 1 ? punctSplit : spaceSplit;
            const sliceIdx = punctSplit.length > 1 ? 1 : words.length-1;

            const ready = words.slice(0, sliceIdx).join(" ");
            //const nextBuffer = 
            if (ready) {
                this.isSpeaking = true;
                speak(ready).then(() => {
                    this.isSpeaking = false;
                    //this.finisher();
                    //this.maybeFinish(this.buffer);
                });
            }
            this.buffer = words.slice(sliceIdx).join(" ");
        }, 650);
    }

    async inferenceDone() {
        console.log("inferenceDone")
        this.isInferenceDone = true;

        if (!this.enabled) return;        

        while (true) {
            await new Promise(resolve => setTimeout(resolve, 100));
            // busy wait is simple
            if (!this.isSpeaking) {
                speak(this.buffer).then(this.onSpeakEnd);
                break;
            }
        }
        // if (this.isSpeaking) {
        //     this.finisher = () => {
        //         speak(this.buffer).then(this.onSpeakEnd);
        //         this.finisher = () => {};
        //     }
        // } else {
        //     speak(this.buffer).then(this.onSpeakEnd);
        // }
    }

    // maybeFinish(nextBuffer: string) {
    //     console.log("maybeFinish")
    //     // FIXME: is that correct?
    //     if (this.isInferenceDone) return;
    //     //this.isInferenceDone = true;

    //     if (!this.enabled) return;

    //     speak(nextBuffer).then(this.onSpeakEnd);
    // }
}

export const globalTTS = new TTS();

export default { speak, state, stopSpeaking, enable, disable }
